export interface Path {
  pathname: string;
  search?: string;
  hash?: string;
}

export const OIDC_REDIRECT_URI_KEY = 'katOne:redirect_uri';

export function setRedirectUri({
  pathname,
  search = '',
  hash = '',
}: Path): void {
  if (pathname === '/logout' || pathname === '/login' || pathname === '/auth/callback' || pathname === '/') return;
  const redirectUri = `${pathname}${search}${hash}`;
  if (redirectUri.length > 0) {
    window.sessionStorage.setItem(OIDC_REDIRECT_URI_KEY, redirectUri);
  }
}

export function getRedirectUri(): string | null {
  return window.sessionStorage.getItem(OIDC_REDIRECT_URI_KEY);
}

export function isServiceCloudRedirectUri(value?: string | null): boolean {
  if (!value) return false;

  const isRelativeSameAppRoute = value.startsWith('/') && !value.startsWith('//');
  const isAbsoluteUrl = /^https?:\/\//i.test(value);
  if (!isRelativeSameAppRoute && !isAbsoluteUrl) return false;

  try {
    const url = new URL(value, window.location.origin);
    return url.origin === window.location.origin && url.pathname === '/oauth/service-cloud';
  } catch {
    return false;
  }
}
